import { connect } from 'react-redux'
import RulesCreationIndex from '..'
import { getListOfCompanies } from '../../../../JobRoles/NewJobRole/actions'
import {
  getCorporateListFromCorporate,
  getInstituteRulesById,
  setUpNewRules,
  updateRules,
} from '../../../action'

import { getCorporateList } from '../../../../Corporate/actions'
import selectors from '../../../selectors'

const mapStateToProps = state => ({
  instituteCampusId: state.auth.instituteDetails.id,
  getRuleDetails: selectors.getRuleDetailsById(state),
  rulesDegreesMetrics: selectors.getRulesDegreesMetrics(state),
})

const mapDispatchToProps = {
  getInstituteRulesById,
  updateRules,
  getCorporateListFromCorporate,
  setUpNewRules,
  getListOfCompanies,
  getCorporateList,
}

export default connect(mapStateToProps, mapDispatchToProps)(RulesCreationIndex)
